module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="tips-right">\n	<div class="glyphicon glyphicon-ok"></div>\n	<div class="content">\n		' +
((__t = ( content )) == null ? '' : __t) +
'\n	</div>\n</div>';

}
return __p
};